import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTMobileComponent } from './simple-icons-t-mobile.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTMobileComponent ],
    exports:      [ SimpleIconsTMobileComponent ],
    bootstrap:    []
})
export class SimpleIconsTMobileModule {}
